const FULL_SIZE_MAX_LENGTH = 10;
const STEP_DOWN_MAX_LENGTH = 13;

/** A long amount steps down a size so it is shown in full, even in the narrowest card. */
export function getAmountSizeClass(amountText: string) {
  if (amountText.length <= FULL_SIZE_MAX_LENGTH) return 'text-3xl';
  return amountText.length <= STEP_DOWN_MAX_LENGTH ? 'text-2xl' : 'text-xl';
}
